import React, {Component} from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../assets/whypc/css/swiper.css';
import '../../../assets/whypc/css/pagination.min.css';
import mySwiper,{ Autoplay, Pagination } from "swiper";


import ReactDOM from 'react-dom';
import Api from "../../model/Api";
import Axios from "axios";
import {Link, Redirect} from 'react-router-dom';
import {Layout} from 'antd';
import '../../../assets/whypc/css/base.css';
import '../../../assets/whypc/css/zhuanti.css';
import zhuantiFoot from "../../../assets/whypc/image/list6.png";
import main from  '../../../assets/whypc/css/main.css';
// 轮播组件
import LunBoControl from './LunBoControl';
import beian from "../../../assets/whypc/image/beian.png";




const { Header, Content,Footer } = Layout;
mySwiper.use([Autoplay, Pagination])
class Zhuanti extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
        	seletKey:2,
			bl:'?x-oss-process=style/wbpdt',
			bannerlist:[],
			navigation:[],
			imagedh:[],
			imgArray: [
				'',
				'',
				'',
				'',
				'',
			],
			linkArray: [
				"#",
				"#",
				"#",
				"#",
				"#",
			],
			title:[
				"",
				"",
				"",
				"",
				""
			],
			lunboObject: {
				"width":1323,//幻灯片的宽度
				"height":388,//幻灯片的高度
				"imgWidth":690,//幻灯片第一帧的宽度
				"interval": 2000,//幻灯片滚动的间隔时间
				"scale":0.76, //记录显示比例关系
				"number":5,
				"autoPlay":true,
				"vertical":"center",  // center或者bottom,居中对齐或底部对齐
				"tweenString":"QuadEaseIn" // 运动方式，缓冲曲线
			},
			getData:false
        }
    }
	componentDidMount(){
		window.scrollTo(0,0)
		this.getbanner(1);
		this.getnavigation(2);
		this.getimgdh(3);
		this.getzhibo(5);
		this.setState({
			getData:true,
		})
	}
	getnavigation=(type)=>{
		var params = new URLSearchParams();
		params.append('type',type);
		params.append('listOrder',1);
		params.append("current",1)
		params.append('size',15);
		Axios.post(Api.getzhuantibanner, params)
			.then((res) => {
				let newArray = [];

				let blist=res.data.data.list
				blist.forEach((list,index) => {
					newArray.push({
						'id':blist[index]['id'],
						'coverImageUrl':blist[index]['coverImageUrl'],
						'serialNumber':blist[index]['serialNumber'],
						'title':blist[index]['title']
					})
				})
				this.setState({
					navigation:newArray
				})
			})
	}
	getbanner=(type)=>{
		var params = new URLSearchParams();
		params.append('type',type);
		params.append('listOrder',3);
		params.append("current",1)
		params.append('size',15);
		Axios.post(Api.getzhuantibanner, params,)
			.then((res) => {
				let newListArray = [];
				let bannerlist=res.data.data.list
				bannerlist.forEach((list,index) => {
					newListArray.push({
						'id':bannerlist[index]['id'],
						'coverImageUrl':bannerlist[index]['coverImageUrl'],
						'serialNumber':bannerlist[index]['serialNumber'],
					})
				})
				this.setState({
					bannerlist:newListArray
				})

			})
	}
	getimgdh=(type)=>{
		var params = new URLSearchParams();
		params.append('type',type);
		params.append('listOrder',1);
		params.append("current",1)
		params.append('size',15);
		Axios.post(Api.getzhuantibanner, params,)
			.then((res) => {
				let imagesArray = [];
				let bslist=res.data.data.list
				bslist.forEach((list,index) => {
					imagesArray.push({
						'id':bslist[index]['id'],
						'coverImageUrl':bslist[index]['coverImageUrl'],
						'serialNumber':bslist[index]['serialNumber'],
						'title':bslist[index]['title']
					})
				})
				this.setState({
					imagedh:imagesArray
				})

			})
	}
	getzhibo=(size)=>{
		Axios.get(Api.getLives+'?current=1&size='+size).then((infores)=>{
			let vlist=infores.data.data.list;
			let imgArrays=[];
			let titleArray=[];
			let linkArrays=[];
			vlist.forEach((list,index)=>{
				imgArrays.push(vlist[index]['cover_img_url']);
				titleArray.push(vlist[index]['activity_name']);
				linkArrays.push('/#/list?typeid=4&serialNumber=&id=10');
			})
			this.setState({
				imgArray:imgArrays,
				title:titleArray,
				linkArray:linkArrays
			})
		})
	}
	gotolist=(serialNumber)=>{
		return <Redirect to={{pathname: `/list`} }/>;
	}
    render(){
        const contentStyle = {
            height: '160px',
            color: '#fff',
            lineHeight: '160px',
            textAlign: 'center',
            background: '#364d79',
        };
        return(
			!this.state.getData?(<div className="content">loading....</div>):(
            <div className="zhuantidiv">
			 <Swiper
					loop={this.state.bannerlist && this.state.bannerlist.length > 1}
			        slidesPerView={1}
			        modules={[Pagination,Autoplay]}
					autoplay={{
					          delay: 2500,
					          disableOnInteraction: false,
					        }}
			        pagination={{
			          clickable: true,
			        }}
			       // modules={[Pagination]}
			        className="mySwiper"
			      >
				 {this.state.bannerlist.map((item,key)=>(
			        <SwiperSlide key={key} onClick={()=>this.props.history.replace("/list?typeid=1&serialNumber="+item.serialNumber+"&id="+item.id)}><img src={item.coverImageUrl+this.state.bl} alt={item.coverImageUrl}/></SwiperSlide>
					 ))}

			      </Swiper>

				<div className="fenlei1">
					<ul className="fenlei1-list">
						{this.state.navigation.map((item,key)=>(
					<Link to={"/list?typeid=2&serialNumber="+item.serialNumber+"&id="+item.id}>
						<li className="fenlei1-item" key={key}>
							<img className="fenlei1-img" src={item.coverImageUrl+this.state.bl} alt={item.coverImageUrl}/>
							<div className="fenlei1-name">
								{item.title}
							</div>
						</li>
						</Link>
						))}

					</ul>
				</div>
                <div className="fenlei2">
					<ul className="fenlei2-list">
						{this.state.imagedh.map((item,key)=>(
							<Link to={"/list?typeid=3&serialNumber="+item.serialNumber+"&id="+item.id}>
								<li className="fenlei2-item"  key={key}>
									<img className="fenlei2-img" src={item.coverImageUrl+this.state.bl} alt={item.coverImageUrl}/>
								</li></Link>
						))}
					</ul>
				</div>
				<div className="jingcai-zhibo">
					<div className="jingcai-title">精彩直播</div>
					<Link to={"/list?typeid=4&serialNumber=&id=10#list-middle"}><div className="jingcai-more" > 更多>> </div></Link>
				</div>
				<div className={main['ad-img']}>
				    <LunBoControl lunboObject={this.state.lunboObject} imgArray={this.state.imgArray} title={this.state.title} linkArray={this.state.linkArray} />
				</div>
                <div className="zhuanti-dibu">
                	<img className="" src={zhuantiFoot+this.state.bl} alt={zhuantiFoot}/>
                </div>

				<Footer className="bootomss">
					<div className="feet" >
						<p>联系电话：4008809382 |< a href="/#">服务条款</ a> | < a
							href="/#" onClick="feedBack()"> 意见反馈</ a></p>
						<p>
							<a href="https://www.hnbxwhy.com/#/Xkz" target = "_blank" rel="noopener noreferrer"> 增值电信业务经营许可证：豫B2-20130011 | </a>
							<a href="http://video.hnbxwhy.com/9222976/wlwhjyxkz.png" target="_blank" rel="noopener noreferrer">网络文化经营许可证：豫网文[2024]1532-018号</a>
						</p>
						<p>
							<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">ICP备案号：豫B2-20130011-4 Copyright &copy; 2014-2024
								www.hnbxwhy.com 河南百姓文化云版权所有，未经授权禁止复制或镜像<img src={beian} alt="百姓文化云备案"/></a>
						</p>
						{/*<p>*/}
						{/*    <a href="http://video.hnbxwhy.com/9222976/wlwhjyxkz.png"> 网络文化经营许可证：豫网文[2024]1532-018号</a>*/}
						{/*    <a href="https://www.iyunshu.com/marketing.html?pageId=2307050005718383">*/}
						{/*        <p style={{float: "left"}}>增值电信业务经营许可证：豫B2-20130011 |*/}
						{/*            Copyright &copy; 2014-2024 www.hnbxwhy.com 文化云*/}
						{/*            版权所有，未经授权禁止复制或镜像</p></a>*/}
						{/*      <a href="https://beian.miit.gov.cn/#/Integrated/index">  <img src={beian} alt="百姓文化云备案"*/}
						{/*             style={{padding_left: '5px', padding_top: '4px'}}/></a>*/}

						{/*</p>*/}
					</div>

				</Footer>

            </div>
			)
        )
    }

}
export default Zhuanti;
